export default __webpack_public_path__ + "static/media/itaucard.8333dce7.svg";